import React from 'react';
import { Link } from 'react-router-dom';

interface DropdownItemProps {
  label: string;
  router: string;
  icon: React.ReactNode;
  handleLogout?: () => void;
}

const DropdownItem: React.FC<DropdownItemProps> = ({ label, router, icon, handleLogout }) => {

  if (label !== 'Logout')
    return (
      <Link to={router} className="dropdown-navigation-item">
        {icon}
        <p className='m-0'>{label}</p>
      </Link>
    );

  return (
    <div
      className="dropdown-navigation-item logout"
      onClick={() => handleLogout()}
    >
      {icon}
      <p className='m-0'>{label}</p>
    </div>
  );
};

export default DropdownItem;
